import { Dialog, Transition } from '@headlessui/react'
import { useIsMobileScreen } from 'hooks/useMediaQuery'
import { Fragment, useEffect, useRef, useState } from 'react'

interface DefaultModalParams {
  closeModal: () => void
  isOpen: boolean
  children: JSX.Element
  containerClassNames?: string;
}
export default function DefaultMobileModal({ isOpen, closeModal, children, containerClassNames

}: DefaultModalParams) {
  const isMobile = useIsMobileScreen()
  const modalRef = useRef<any>(null);
  const contentRef = useRef<any>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (contentRef.current && !contentRef.current.contains(event.target as Node)) {
        closeModal();
      }
    };
    if (isOpen) {
      document.addEventListener('click', handleClickOutside);
    }
    if (!isOpen) {
      document.removeEventListener('click', handleClickOutside);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);


  return (
    <>
      <Transition appear show={isOpen && isMobile} as={Fragment}>
        <Dialog as="div" className="relative z-[1000]" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-10 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto"
            ref={modalRef}
          >

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100 translate-y-0"
              leaveTo="opacity-0 scale-100 translate-y-full"
            >
              <div className={`w-full rounded-t-2xl bg-[#FEFEFE] px-6 py-4 fixed max-h-[90vh] overflow-y-scroll ${containerClassNames || 'bottom-9'}`}
                data-testid="test-mobile-modal"
              >
                {/* <div className='flex justify-center items-center mb-4'>
                  <div className='w-10 h-1 bg-[#BFC2C8] rounded-lg' />
                </div> */}
                <div ref={contentRef}>
                  {children}
                </div>
              </div>
            </Transition.Child>

          </div>
        </Dialog>
      </Transition>
    </>
  )
}
